export default __webpack_public_path__ + "static/media/ico_video.1f55a14a.svg";